module.exports = __webpack_public_path__ + "img/link_w.592f1727.svg";